module.exports = __webpack_public_path__ + "img/icon-whole-word.b6661bfd.svg";